unit ActiveBaseRequest;
{

/* Initial. */

}

interface

uses
  BaseRequest;

type
  TActiveBaseRequest = class(TBaseRequest)
  private
    active: Byte;
  public
    constructor Create(const String_LoginKey: String; const Byte_Active: Byte);
  end;

implementation

constructor TActiveBaseRequest.Create(const String_LoginKey: String; const Byte_Active: Byte);
begin
  inherited Create(String_LoginKey);

  active := Byte_Active;
end;

end.
